import React from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import FightSuccess from "./FightSuccess"
import PaySuccess from "./PaySuccess"
import PaySuccessEverVault from "./PaySuccessEverVault"

import NoTicketsDownloadApp from "./NoTicketsDownloadApp"
import RemainingTickets from "./RemainingTickets"

import {
  PARKING_FLOW_TYPE,
  PAYMENT_PROVIDERS,
  REQUEST_STATUSES,
} from "~/utilities/constants"
import DesktopContainer from "~/components/DesktopContainer"
import SearchForm from "~/components/traffic/lookup/Forms"
import Spacer from "~/components/Spacer"
import TicketLoader from "~/components/TicketLoader/TicketLoader"
import Link from "~/components/Link"

const GradientBackground = styled.div`
  display: flex;
  flex-grow: 1;
  background-image: linear-gradient(
    180deg,
    ${(props) => props.theme.colors.background.main} 13%,
    ${(props) => props.theme.colors.background.page} 100%
  );
`

const SearchFormContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.isMobile ? "100px" : "800x")};
  height: ${(props) => (props.isMobile ? "100px" : "230x")};
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 9px 24px rgba(0, 0, 0, 0.1);
  padding: 20px;
`

const SubText = styled.div`
  color: black;
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  line-height: 1.4rem;
  font-weight: normal;
  text-align: center;
  display: flex;
  flex-direction: row;
  max-width: 1200px;
  width: 100%;
`

const Title = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextBold};
  color: ${(props) => props.theme.colors.black};
  font-size: ${(props) => (props.isMobile ? "1.5625rem" : "1.875rem")};
  text-align: left;
`
const DisclaimerText = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  color: ${(props) => props.theme.colors.text.subContent};
  font-size: 0.95rem;
`

const GradientWrapper = ({ type, children }) => {
  if (type === PARKING_FLOW_TYPE.pay) {
    return <GradientBackground>{children}</GradientBackground>
  }
  return children
}
@inject((all) => ({
  currentHost: all.store.ui.currentHost,
  isMobile: all.store.ui.isMobile,
  payableSelectableCount: all.store.parkingFlow.results.payableSelectableCount,
  fightableSelectableCount:
    all.store.parkingFlow.results.fightableSelectableCount,
  type: all.store.parkingFlow.flow.type,
  fetchingTicketsStatus: all.store.trafficLookup.fetchingTicketsStatus,
  paymentProcessor: all.store.payment.paymentProcessor,
}))
@observer
class Success extends React.Component {
  render() {
    const {
      payableSelectableCount,
      fightableSelectableCount,
      type,
      currentHost,
    } = this.props
    const remainingTickets =
      type === PARKING_FLOW_TYPE.fight
        ? fightableSelectableCount
        : payableSelectableCount
    const alternateRemaining =
      type === PARKING_FLOW_TYPE.fight
        ? payableSelectableCount
        : fightableSelectableCount

    const showRemaining = remainingTickets || alternateRemaining || 0
    const rand = Math.ceil(
      Math.random() *
        (parseInt(process.env.PERCENTAGE_OF_USERS_TO_SHOW_LOOKUP, 10) || 0)
    )
    let CardContainer
    if (
      (currentHost.includes("paynyctickets.com") ||
        currentHost.includes("staging")) &&
      this.props.type === PARKING_FLOW_TYPE.pay &&
      rand === 1
    ) {
      CardContainer = (
        <div>
          <Spacer mobile={10} desktop={29} />
          <SubText>
            Do you have any other open violations? You can use the tool below to
            check if you may have other outstanding tickets such as a moving
            violation, improper stopping, or other traffic ticket in NYC. Check
            now to ensure you don’t face unwanted consequences.
          </SubText>
          <Spacer mobile={37} desktop={26} />
          <SearchFormContainerWrapper>
            <Title>Lookup your New York Traffic Tickets</Title>
            <Spacer mobile={37} desktop={26} />
            <SearchForm />
            <DisclaimerText>
              By clicking <b>“Search Tickets”</b> above, you also agree to
              receive autodialed promotional, and personalized marketing,
              informational, or administrative messages (e.g., cart reminders)
              at the phone number and email provided above until you opt-out,
              which you may do at any time. Consent is not a condition of
              purchase. Reply STOP to unsubscribe or HELP for assistance.
              Message and data rates may apply. Message frequency may vary. You
              also agree to our{" "}
              <Link href="https://www.appwinit.com/terms-of-use">
                Terms of Service
              </Link>{" "}
              and{" "}
              <Link href="https://www.appwinit.com/privacy-policy">
                Privacy Policy
              </Link>
              , and represent to us that the mobile phone number and e-mail
              address you provide to us belong to you and no one else and agree
              to promptly notify us of any changes.
            </DisclaimerText>
          </SearchFormContainerWrapper>
        </div>
      )
    }

    if (this.props.fetchingTicketsStatus === REQUEST_STATUSES.loading)
      return <TicketLoader fetcher="NY" />

    let successComponent
    if (this.props.type === PARKING_FLOW_TYPE.fight) {
      successComponent = <FightSuccess />
    } else if (this.props.paymentProcessor === PAYMENT_PROVIDERS.evervault) {
      successComponent = <PaySuccessEverVault />
    } else {
      successComponent = <PaySuccess />
      
    }

    return (
      <GradientWrapper type={this.props.type}>
        <DesktopContainer>
          {successComponent}
          <Spacer mobile={10} desktop={29} />
          {showRemaining ? <RemainingTickets /> : <NoTicketsDownloadApp />}
          {CardContainer}
        </DesktopContainer>
      </GradientWrapper>
    )
  }
}

export default Success
